<div class="grid grid-cols-1 gap-6 md:grid-cols-2">
  <xemex-installation-alarm-settings-card />

  @if (showAttributes() && feeding().length) {
    <xemex-installation-pv-forecast-card
      class="empty:hidden"
      [installation]="installation()"
      [devices]="feeding()"
    />
  }
</div>
